import React, { useState, useEffect } from "react";
import { format, addMonths } from 'date-fns';
import { backendGet } from "../../../helpers/callBackend";
import { Dropdown, Menu, Select, Spin } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { downloadPDF } from "../../../helpers/downloadPDF";
import CircularProgress from '@mui/material/CircularProgress';

const { Option } = Select;

const GenericBankAccountStatements = ({ bankAccountSource, bankAccountId, bankAccountInfo, bulkDownloadEnabled, onChange, hasStatements }) => {
  const [loadingStatementList, setLoadingStatementList] = useState(true);
  const [statementName, setStatementName] = useState("");
  const [statements, setStatements] = useState([]);

  useEffect(() => {
    if (bankAccountSource) {
      setStatements(getMonthsDropdown());
      setLoadingStatementList(false);
    }
  }, [bankAccountSource]);

  const getMonthsDropdown = () => {
    const monthsArray = [];
    const now = new Date();
    for (let i = 1; i <= 24; i++) {
      const date = addMonths(now, -i);
      const statement = { id: i, attributes: { period: format(date, "yyyy-MM") } };
      monthsArray.push(statement);
    }
    return monthsArray;
  };

  const handleDownload = (period, value) => {
    backendGet(
      { loading: setLoadingStatementList },
      "/api/bank-account/statement/",
      {
        params: {
          bank_account_id: bankAccountId,
          statement_id: value,
          period: period,
        },
      },
      "loading",
      (s, d) => {
        downloadPDF(
          d,
          `statement-${bankAccountInfo.account_description
            .toLowerCase()
            .replace(/ /g, "-")}.pdf`
        );
        return s;
      }
    );
  };

  const configureOnClick = (name, entry_id) => {
    if (bulkDownloadEnabled) {
      setStatementName(name);
      return onChange(bankAccountId, entry_id);
    }
    return handleDownload(name, entry_id);
  };

  const bulkDownloadDropdown = () => (
    <Select
      placeholder="Statements"
      onChange={onChange}
    >
      {statements.map(entry => (
        <Option key={entry.id} value={entry.id}>
          {entry.attributes.period}
        </Option>
      ))}
    </Select>
  );

  const singleStatementDownloadDropdown = () => (
    <Dropdown
      overlay={
        <Menu style={{ maxHeight: '300px', overflowY: 'scroll' }}>
          {statements.map(entry => (
            <Menu.Item
              key={entry.id}
              onClick={() => configureOnClick(entry.attributes.period, entry.id)}
            >
              {entry.attributes.period}
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <span style={{ fontWeight: "400", fontSize: "14px", color: "#1890ff", cursor: "pointer" }}>
        {bulkDownloadEnabled ?
          (statementName.length > 0 ? statementName : "Select Statement") :
          <div>View Statements <ArrowRightOutlined /></div>
        }
      </span>
    </Dropdown>
  );

  return (
    <>
      {loadingStatementList && hasStatements ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '100%' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {hasStatements && statements.length > 0 ? (
            bulkDownloadEnabled ? bulkDownloadDropdown() : singleStatementDownloadDropdown()
          ) : (
            <div>
              {bulkDownloadEnabled ? "Sorry, no statements are available" : (
                <span style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "rgba(0,0,0,0.25)",
                }}>
                  View Statements <ArrowRightOutlined />
                </span>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default GenericBankAccountStatements;
